import { createAuthClient } from "better-auth/vue";

export const authClient = createAuthClient();

export function authErrorMessage(error: { message?: string; code?: string } | null, fallback: string): string {
  if (!error) return fallback;
  switch (error.code) {
    case "INVALID_EMAIL_OR_PASSWORD": return "Email or password is incorrect.";
    case "EMAIL_NOT_VERIFIED": return "Verify your email before signing in.";
    case "PASSWORD_TOO_SHORT": return "Use at least 10 characters for your password.";
    case "TOO_MANY_REQUESTS": return "Too many attempts. Wait a moment and try again.";
    case "INVALID_TOKEN": return "That secure link is invalid or has expired.";
    default: return error.message || fallback;
  }
}
